import { classNames } from 'libs/react';
import { MediaType } from 'libs/media/MediaType';
import { React } from 'libs/react';
import './FileType.scss';
/**
 * @component FileType
 * @since 1.0.0
 */
export function FileType(props) {
    const { style, value } = Object.assign({ style: 'normal' }, props);
    const label = MediaType.labels[value];
    if (label == null) {
        return null;
    }
    const className = classNames('file-type', 'file-type--' + style, props.className);
    return React.createElement("span", { className: className }, label);
}
